/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_AvailableInputs */

const en_directory_submit_check_available = /** @type {(inputs: Directory_Submit_Check_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not listed yet — you can submit it.`)
};

const zh_directory_submit_check_available = /** @type {(inputs: Directory_Submit_Check_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未收录 — 可以提交。`)
};

/**
* | output |
* | --- |
* | "Not listed yet — you can submit it." |
*
* @param {Directory_Submit_Check_AvailableInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_available = /** @type {((inputs?: Directory_Submit_Check_AvailableInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_AvailableInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_available(inputs)
	return zh_directory_submit_check_available(inputs)
});
export { directory_submit_check_available as "directory.submit.check.available" }